import React, { Fragment, useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import PropTypes from "prop-types";
import { Helmet } from "react-helmet";
import Navbar from "web/components/Navbar";
import Footer from "web/components/Footer";
import twitter from "web/assets/images/twitter.svg";
import facebook from "web/assets/images/facebook.svg";
import linkedin from "web/assets/images/linkedin.svg";
import headerLogo from "web/assets/images/NewHeaderLogo.png";
import { useDispatch, useSelector } from "react-redux";
import { fetchLanguageContentNew } from "redux/actions/language";
import ChatBox from "web/components/ChatBox";
import RefreshTokenHOC from "web/components/RefreshTokenHOC";

import "./layout.scss";
import LandingFooter from "web/components/AppFooterV2";
import useRefreshToken from "../RefreshTokenHOC/useRefreshToken";

const Layout = ({
  children,
  transparentHeader,
  paddingTop,
  userType,
  pageType,
  tabType,
  selectedSearch,
  title,
  callbackLayout,
  topBarViewMobile,
}) => {
  const dispatch = useDispatch();
  const currentLanguage = useSelector(
    (state) => state.language.currentLanguage
  );
  const languageContentNew = useSelector(
    (state) => state.language.languageContentNew
  );
  const [pageLanguageContents, setPageLanguageContents] = useState();
  let history = useHistory();

  // useEffect(() => {
  //   if (languageContentNew?.Footer_Page)
  //     setPageLanguageContents(languageContentNew.Footer_Page);
  //   else dispatch(fetchLanguageContentNew(currentLanguage));
  // }, [languageContentNew]);  

  useEffect(() => {
    let userRole = localStorage.getItem('accountType')
    if (userRole === 'Admin') history.push("/admin");
  }, [])

  const privacyPolicy = () => {
    history.push("/privacy-policy");
  };
  const websiteTerm = () => {
    history.push("/terms-of-use");
  };

  const imageStyle = { height: "26px" };

  useRefreshToken();

  return (
    <Fragment>
      <Helmet>
        <meta name="viewport" content="width=device-width" />
      </Helmet>
      <div className="app-container">
        <Navbar
          userType={userType}
          pageType={pageType}
          tabType={tabType}
          selectedSearch={selectedSearch}
          searchTitle={title}
          callbackLayout={callbackLayout}
          topBarViewMobile={topBarViewMobile}
        />
        <div
          className={`app-body ${paddingTop ? "app-body-top-padding" : ""} `}
        >
          {children}
        </div>
        <ChatBox />
        {/*<RefreshTokenHOC />*/}
        <LandingFooter />
        {/* <Footer>
          <Footer.Wrapper>
            <Footer.Row>
              <Footer.Column>
                <Footer.Title>
                  {pageLanguageContents?.Footer_section_1[0]?.Company}
                </Footer.Title>
                <Footer.Link onClick={(e) => history.push("/dashboard")}
                  target="_blank"
                >
                  Main Page
                </Footer.Link>
                <Footer.Link onClick={(e) => history.push("/who-its-for")}>
                  Who’s it For
                </Footer.Link>
                <Footer.Link onClick={(e) => history.push("/how-it-works")}>
                  How it works
                </Footer.Link>
              </Footer.Column>
              <Footer.Column>
                <Footer.Title>Site</Footer.Title>
                <Footer.Link
                  onClick={(e) => {
                    if (userType === "Seller") {
                      let params = "?params=true";
                      let obj = {
                        params,
                        pageType: "PostLoad",
                        expanded: "sideBar",
                      };
                      dispatch({ type: "SEARCH_INVENTORY", payload: obj });

                      history.push({
                        pathname: "/nearby-inventory",
                      });
                    } else {
                      let params = "?params=true";
                      let obj = {
                        params,
                        pageType: "PostInventory",
                        expanded: "sideBar",
                      };
                      dispatch({ type: "SEARCH_INVENTORY", payload: obj });

                      history.push({
                        pathname: "/nearby-inventory",
                      });
                    }
                  }}
                >
                  Nearby
                </Footer.Link>
                <Footer.Link
                  onClick={(e) => {
                    let paginationObj = {
                      selectedPage: 1,
                    };
                    dispatch({
                      type: "BIDS_PAGINATION",
                      payload: paginationObj,
                    });
                    if (userType === "Seller") {
                      let obj = {
                        postType: "PostLoad",
                        type: "postedNeeds",
                        activePage: "PostLoad",
                        activeSearch: "Dashboard",
                        expanded: "panel1",
                      };
                      dispatch({ type: "CREATED_NEEDS", payload: obj });

                      history.push({
                        pathname: "/my-posted-pallet-needs",
                      });
                    } else {
                      let obj = {
                        postType: "PostInventory",
                        type: "palletOffers",
                        activePage: "PostInventory",
                        expanded: "panel2",
                      };
                      dispatch({ type: "CREATED_INVENTORY", payload: obj });

                      history.push({
                        pathname: "/my-posted-pallet-inventory",
                      });
                    }
                  }}
                >
                  My Posts
                </Footer.Link>
                <Footer.Link
                  onClick={(e) => {
                    if (userType === "Seller") {
                      let obj = {
                        postType: "PostLoad",
                        type: "bidsPalletNeeds",
                        activePage: "PostLoad",
                        expanded: "panel2",
                      };
                      dispatch({ type: "BID_NEEDS", payload: obj });

                      history.push({
                        pathname: "/view-my-bids-on-pallet-needs",
                      });
                    } else {
                      let obj = {
                        postType: "PostInventory",
                        type: "bidsPalletOffers",
                        activePage: "PostInventory",
                        expanded: "panel1",
                      };
                      dispatch({ type: "BIDS_INVENTORY", payload: obj });

                      history.push({
                        pathname: "/view-my-offers-on-pallet-inventory",
                      });
                    }
                  }}
                >
                  My Bids & Offers
                </Footer.Link>
                <Footer.Link
                  onClick={(e) => {
                    let obj = {
                      pageType: "MyOrder",
                    };
                    dispatch({ type: "ORDERS", payload: obj });
                    history.push({
                      pathname: "/my-orders",
                    });
                  }}
                >
                  My Orders
                </Footer.Link>
                <Footer.Link
                  onClick={(e) => {
                    let obj = {
                      pageType: "MyCommunity",
                      expanded: "sideBar",
                    };
                    dispatch({ type: "MYCOMMUNITY", payload: obj });

                    history.push({
                      pathname: "/my-community",
                    });
                  }}
                >
                  My Community
                </Footer.Link>
                <Footer.Link
                  onClick={(e) => {
                    let obj = {
                      pageType: "ClaimRaise",
                      expanded: "sideBar",
                    };
                    dispatch({ type: "RESOLUTION_CENTER", payload: obj });

                    history.push({
                      pathname: "/resolution-center",
                    });
                  }}
                >
                  Resolution Center
                </Footer.Link>
              </Footer.Column>
              <Footer.Column>
                <Footer.Title>
                  {pageLanguageContents?.Footer_section_3[0]?.Account}
                </Footer.Title>
                <Footer.Link
                  onClick={(e) =>
                    history.push("/operational-terms-and-conditions")
                  }
                >
                  {pageLanguageContents?.Footer_section_3[5]?.Privacy}
                </Footer.Link>
              </Footer.Column>
              <Footer.Column>
                <Footer.Link onClick={(e) => history.push("/dashboard")}>
                  <Footer.FooterLogo>
                    <img src={headerLogo} alt="logo" />
                  </Footer.FooterLogo>{" "}
                </Footer.Link>
                <Footer.Link href="tel:+1-877-777-7495">
                  1-877-777-7495
                </Footer.Link>
                <Footer.Link href="mailto:support@pallettrader.com">
                  support@pallettrader.com
                </Footer.Link>
                <div>
                  <Footer.Link
                    href="https://www.linkedin.com/company/pallettrader/"
                    target="_blank"
                  >
                    <Footer.SocialIcon>
                      <img
                        style={imageStyle}
                        src={linkedin}
                        target="_blank"
                        href="https://www.linkedin.com/company/pallettrader/"
                        alt="Linkedin"
                      />
                    </Footer.SocialIcon>
                  </Footer.Link>
                  <Footer.Link
                    href="https://twitter.com/Pallet_trader"
                    target="_blank"
                  >
                    <Footer.SocialIcon>
                      <img
                        style={imageStyle}
                        src={twitter}
                        target="_blank"
                        href="https://twitter.com/Pallet_trader"
                        alt="Twitter"
                      />
                    </Footer.SocialIcon>
                  </Footer.Link>
                  <Footer.Link
                    href="https://www.facebook.com/profile.php?id=100083239285725"
                    target="_blank"
                  >
                    <Footer.SocialIcon>
                      <img
                        style={imageStyle}
                        src={facebook}
                        target="_blank"
                        href="https://www.facebook.com/profile.php?id=100083239285725"
                        alt="Facebook"
                      />
                    </Footer.SocialIcon>
                  </Footer.Link>
                </div>
              </Footer.Column>
            </Footer.Row>
            <Footer.Divider></Footer.Divider>
            <Footer.TermWrapper>
              <Footer.Link onClick={privacyPolicy}>Privacy Policy</Footer.Link>
              <Footer.Link onClick={websiteTerm}>
                Website Term of Use
              </Footer.Link>
              <Footer.Term>
                © 2020-{new Date().getFullYear()} Delancey Street Pallet Traders LLC, or its
                affiliates. All rights reserved.
              </Footer.Term>
            </Footer.TermWrapper>
          </Footer.Wrapper>
        </Footer> */}
      </div>
    </Fragment>
  );
};

Layout.propTypes = {
  transparentHeader: PropTypes.bool,
  paddingTop: PropTypes.bool,
};

Layout.defaultProps = {
  transparentHeader: false,
  paddingTop: false,
};

export default Layout;
